import {
  AccountClient,
  GET_ALL_CUSTOM_FIELDS,
  TicketClient,
  GET_ALL_TECH_GROUP
} from '@nile/graphql';
import { GET_ALL_FIELDS_V2 } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { GET_COMPANY_SITE_LIST } from '@nile/itsm/src/graphql';
import { GET_COMPANY_USERS } from '@nile/graphql/src/Query/automationrules';
import { GET_TECHNICIAN_ROLES } from '@nile/banyan/src/Graphql/Mutations/role';
import { GET_ROLES } from '@nile/banyan/src/Graphql/Mutations/role';
import {
  GET_ALLMSP_DESIGNATIONS,
  GET_MSP_BUSINESSFUNCTIONS,
  GET_MSP_TEAMLIST
} from '@nile/banyan/src/Graphql/Mutations/employee';
import { ALL_SHARD_MODULES } from '@nile/components';

const USER_ROLE_ID = '2';
const DEFAULT_LISTINFO = {
  page: 1,
  pageSize: 100
};

export const getClient = (field) => {
  switch (field) {
    case 'customFields':
      return AccountClient;
    default:
      return AccountClient;
  }
};

export const getVariables = (field) => {
  switch (field) {
    case 'customFields':
      return {
        input: ALL_SHARD_MODULES.companyUser
      };
    case 'siteId':
      return {
        input: {
          page: DEFAULT_LISTINFO.page,
          pageSize: DEFAULT_LISTINFO.pageSize
        }
      };
    case 'reportingManager':
      return {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'roleId':
      return GET_ROLES;
    case 'technicianroleId':
      return GET_TECHNICIAN_ROLES;
    case 'requesterroleId':
      return GET_ROLES;
    // case 'technicianGroups':
    //   return GET_ALL_TECH_GROUP;
    case 'reportingManager':
      return GET_COMPANY_USERS;
    case 'customFields':
      return GET_ALL_FIELDS_V2;
    case 'designationId':
      return GET_ALLMSP_DESIGNATIONS;
    case 'businessFunctionId':
      return GET_MSP_BUSINESSFUNCTIONS;
    case 'teamId':
      return GET_MSP_TEAMLIST;
    case 'siteId':
      return GET_COMPANY_SITE_LIST;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);
  switch (field) {
    case 'roleId':
    case 'technicianroleId':
    case 'requesterroleId':
    // case 'technicianGroups':
    case 'reportingManager':
    case 'customFields':
    case 'designationId':
    case 'businessFunctionId':
    case 'teamId':
    case 'siteId':
      return client.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  switch (field) {
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'roleId':
      return 'getRoles';
    case 'technicianroleId':
      return 'getTechnicianRoleTypeRoles';
    case 'requesterroleId':
      return 'getRoles';
    // case 'technicianGroups':
    //   return 'getTechnicianGroups';
    case 'reportingManager':
      // return 'getAllEmployees';
      return 'getCompanyUsersList';
    case 'designationId':
      return 'getDesignationList';
    case 'businessFunctionId':
      return 'getBusinessFunctionList';
    case 'teamId':
      return 'getTeamList';
    case 'siteId':
      return 'getCompanySiteList';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'roleId':
    case 'requesterroleId':
      return options?.data?.[key]
        ?.filter((el) => el.roleType?.roleTypeId === USER_ROLE_ID)
        ?.map((el) => ({
          value: el.roleId,
          label: el.name
        }));
    case 'designationId':
      return options?.data?.[key]?.map((el) => ({
        value: el.designationId,
        label: el.name
      }));
    case 'businessFunctionId':
      return options?.data?.[key]?.map((el) => ({
        value: el.businessFunctionId,
        label: el.name
      }));
    case 'teamId':
      return options?.data?.[key]?.map((el) => ({
        value: el.teamId,
        label: el.name
      }));
    case 'siteId':
      return options?.data?.[key]?.sites.map((el) => ({
        value: el.id,
        label: el.name
      }));
    case 'technicianroleId':
      return options?.data?.[key]?.map((el) => ({
        value: el.roleId,
        label: el.name
      }));
    // case 'requesterroleId':
    //   return options?.data?.[key]?.map((el) => ({
    //     value: el.roleId,
    //     label: el.name
    //   }));
    // case 'technicianGroups':
    //   return options?.data?.[key]?.map((el) => ({
    //     value: el.groupId,
    //     label: el.name
    //   }));
    case 'reportingManager':
      return options?.data?.[key]?.userList?.map((el) => ({
        value: el.email,
        label: el.name
      }));
    default:
      return options;
  }
};

export const getRequesterValidationFields = () => {
  return {
    customFields: AccountClient.query({
      query: GET_ALL_FIELDS_V2,
      variables: { input: ALL_SHARD_MODULES.requester }
    })
  };
};

export const modelRequesterValidationFields = (type, { data }) => {
  switch (type) {
    case 'customFields':
      return (
        data?.getAllFields?.filter(
          (field) => field?.fieldCategory === 'CUSTOM'
        ) || []
      );
    default:
      return null;
  }
};

export const getTechnicianImportFieldsUpdated = (currentProduct) => {
  let fields = [
    {
      label: 'dromo.title.firstName',
      key: 'firstName',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'dromo.title.lastName',
      key: 'lastName'
    },
    {
      label: 'admin.myprofile.profile.email',
      key: 'email',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'dromo.validation.emailAddress'
        }
      ]
    },
    {
      label: 'dromo.title.phoneNumber',
      key: 'phoneNumber'
    },
    {
      label: 'entity.designation',
      key: 'designationName'
      // type: 'select',
      // selectOptions: getSelectOptions('designationId')
    },
    {
      label: 'admin.employee.empInfo.business',
      key: 'businessFunctionName'
      // type: 'select',
      // selectOptions: getSelectOptions('businessFunctionId')
    },
    {
      label: 'dromo.title.technicianGroups',
      key: 'technicianGroups'
      // type: 'select',
      // selectOptions: getSelectOptions('technicianGroups')
    },
    // {
    //   label: 'dromo.title.roleName',
    //   key: 'roleId',
    //   type: 'select',
    //   selectOptions: getSelectOptions('roleId')
    // },
    {
      label: 'dromo.title.reportingManager',
      key: 'reportingManager',
      type: 'select',
      selectOptions: getSelectOptions('reportingManager')
    }
  ];
  if (currentProduct == 'IT') {
    fields.splice(
      7,
      0,
      {
        label: 'admin.Technicianrole.technician',
        key: 'technicianroleId',
        type: 'select',
        selectOptions: getSelectOptions('technicianroleId')
      },
      {
        label: 'admin.Requesterrole.requester',
        key: 'requesterroleId',
        type: 'select',
        selectOptions: getSelectOptions('requesterroleId'),
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      }
    );
    fields.push({
      label: 'dromo.title.site',
      key: 'siteId',
      type: 'select',
      selectOptions: getSelectOptions('siteId'),
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    });
  } else {
    fields.splice(6, 0, {
      label: 'entity.team',
      key: 'teamName'
      // type: 'select',
      // selectOptions: getSelectOptions('teamId')
    });
    fields.splice(7, 0, {
      label: 'admin.Technicianrole.technician',
      key: 'technicianroleId',
      type: 'select',
      selectOptions: getSelectOptions('technicianroleId'),
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    });
  }
  return fields;
};
